/**
 * config.ts - i18n Configuration
 *
 * Configures i18next for internationalization with:
 * - 11 supported languages
 * - HTTP backend for loading translations
 * - Browser language detection
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

export const supportedLngs = {
    en: "English",
    ar: "العربية",
    ckb: "کوردی",
    de: "Deutsch",
    it: "Italiano",
    es: "Español",
    fr: "Français",
    cn: "中文",
    ru: "Русский",
    ur: "اردو",
    pl: "Polski"
};

// Determine the correct base path for loading translations
const getLoadPath = () => {
    // In production, use the base path from vite config
    // In development, load from root
    const base = import.meta.env.BASE_URL || '/';
    return `${base}locales/{{lng}}/{{ns}}.json`;
};

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: Object.keys(supportedLngs),
        fallbackLng: 'en',
        debug: false, // Set to false to reduce console noise
        nonExplicitSupportedLngs: true, // Allow language variants
        load: 'languageOnly', // Only load 'en' not 'en-US', prevents 'dev' errors
        ns: ['translation', 'topics'], // Define namespaces
        defaultNS: 'translation', // Default namespace
        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: getLoadPath(),
        },
    });

export default i18n;
